import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';

import appEnums from 'enums/app';
import ConnectionErrorBannerContainer from 'presentation/containers/ConnectionErrorBannerContainer';
import CompositionContainer from 'presentation/containers/CompositionContainer';
import { getChatClientConnectionStatus } from 'app/modules';

export function Footer({ isChatClientConnected, isChatClientReconnecting }) {
  Footer.propTypes = {
    isChatClientConnected: PropTypes.bool.isRequired,
    isChatClientReconnecting: PropTypes.bool.isRequired,
  };

  return (
    <React.Fragment>
      <ConnectionErrorBannerContainer
        isChatClientConnected={isChatClientConnected}
        isChatClientReconnecting={isChatClientReconnecting}
      />
      <CompositionContainer isChatClientConnected={isChatClientConnected} />
    </React.Fragment>
  );
}

export const mapStateToProps = (state, props) => {
  const chatClientConnectionStatus = getChatClientConnectionStatus(state);
  const { CONNECTED, RECONNECTING } = appEnums.chatClientConnectionStatuses;

  return {
    ...props,
    isChatClientConnected: !chatClientConnectionStatus || chatClientConnectionStatus === CONNECTED,
    isChatClientReconnecting: chatClientConnectionStatus === RECONNECTING,
  };
};

const FooterContainer = connect(mapStateToProps)(Footer);

export default FooterContainer;
